const isClipboardItemImageFile = (item) => {
  return item?.kind === 'file' && typeof item.type === 'string' && item.type.toLowerCase().startsWith('image/')
}

const toClipboardImageBlob = (blob) => {
  if (!(blob instanceof Blob)) {
    return null
  }

  return new Blob([blob], {
    type: blob.type || 'application/octet-stream',
  })
}

export const extractPastedImageBlobs = (clipboardData) => {
  if (!clipboardData || typeof clipboardData !== 'object') {
    return []
  }

  const itemList = Array.isArray(clipboardData.items) ? clipboardData.items : Array.from(clipboardData.items ?? [])
  const imageBlobsFromItems = itemList
    .filter((item) => isClipboardItemImageFile(item))
    .map((item) => item.getAsFile?.() ?? null)
    .map((blob) => toClipboardImageBlob(blob))
    .filter((blob) => blob instanceof Blob)

  if (imageBlobsFromItems.length > 0) {
    return imageBlobsFromItems
  }

  const fileList = Array.isArray(clipboardData.files) ? clipboardData.files : Array.from(clipboardData.files ?? [])

  return fileList
    .filter((file) => file instanceof Blob && typeof file.type === 'string' && file.type.toLowerCase().startsWith('image/'))
    .map((blob) => toClipboardImageBlob(blob))
    .filter((blob) => blob instanceof Blob)
}
